@if (label(); as label) {
  <label [for]="innerId()">{{ label }}</label>
}
<p-selectButton
  [options]="options()"
  [(ngModel)]="model"
  [optionLabel]="labelKey()"
  [allowEmpty]="false"
>
  <ng-template let-item pTemplate>
    <span
      class="p-button-label"
      [attr.data-test]="item[testTriggerKey()]"
    >
      @if (labelKey()) {
        {{ item[labelKey()] }}
      } @else {
        {{ item }}
      }
        </span>
  </ng-template>


</p-selectButton>
